import { useMemo } from 'react';

import { isImageGenerationTool } from 'src/data/generationTool';
import { createStateSelectorHook } from 'src/lib/sweetState';
import { MultiPromptTemplatesStore } from 'src/store/multiPromptTemplates';

const useMultiPromptTemplatesState = createStateSelectorHook(MultiPromptTemplatesStore, [
  'multiPromptTemplates',
]);

const INITIAL_STATE = {
  blocks: [],
  isAnyImageSectionExistsInTemplate: false,
  multiPromptTemplateStatus: null,
  multiPromptTemplateCreatedBy: 'another user',
};

export const usePrepareMultiPromptTemplateFields = ({ multiPromptTemplateId }) => {
  const { multiPromptTemplates } = useMultiPromptTemplatesState();

  return useMemo(() => {
    const template = multiPromptTemplates.find((t) => t.id === multiPromptTemplateId);
    if (!template) {
      return INITIAL_STATE;
    }

    const blocks = template.blocks || [];

    const isAnyImageSectionExistsInTemplate = blocks.some((block) =>
      isImageGenerationTool(block.type)
    );

    return {
      blocks,
      isAnyImageSectionExistsInTemplate,
      multiPromptTemplateStatus: template.status,
      multiPromptTemplateCreatedBy: template.createdBy || 'another user',
    };
  }, [multiPromptTemplateId, multiPromptTemplates]);
};
